<template>
  <nav class="app-navigation">
    <div class="start">
      <slot name="start">
        <AppBreadcrumbs :current-route-breadcrumbs="currentRouteBreadcrumbs" />
      </slot>
    </div>
    <div class="end">
      <div class="flex-end end-menu is-flex">
        <slot name="end">
          <div class="menu-item">
            <UserFlyoutMenu />
          </div>
        </slot>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import AppBreadcrumbs from "@/components/AppBreadcrumbs/AppBreadcrumbs.vue"
import UserFlyoutMenu from "./UserFlyoutMenu/UserFlyoutMenu.vue"
import { useBreadcrumbStore } from "@/store/modules/user/useBreadcrumbStore"
interface ICurrentRoute {
  title: string
  translationKey: string
  routeName: string
}

const breadcrumbStore = useBreadcrumbStore()
const currentRouteBreadcrumbs = computed(() => breadcrumbStore.getPageBreadcrumbs)
</script>

<style lang="scss" scoped>
@import "@/styles/utilities/variables";
.is-flex {
  display: flex;
}

.app-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--scl-spacing-16) var(--scl-spacing-24) var(--scl-spacing-16) var(--scl-spacing-32);
  background-color: var(--dih-telekom-background-surface-subtle);
  height: $nav-bar-height;
  &.is-nav-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 60;
  }
}

.end-menu {
  .menu-item {
    margin-right: 15px;
    font-size: var(--scl-font-size-12);
    line-height: 135%;
    color: var(--telekom-color-text-and-icon-standard);
    display: flex;
    align-items: center;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      color: var(--telekom-color-text-and-icon-primary-standard);
      cursor: pointer;
    }
  }
}
</style>
